export default __webpack_public_path__ + "static/media/WAVAX.f39a652e.png";